import { render, staticRenderFns } from "./ChargebeeUpsellSummaryItems.vue?vue&type=template&id=536e4b47&scoped=true&"
import script from "./ChargebeeUpsellSummaryItems.vue?vue&type=script&lang=js&"
export * from "./ChargebeeUpsellSummaryItems.vue?vue&type=script&lang=js&"
import style0 from "./ChargebeeUpsellSummaryItems.vue?vue&type=style&index=0&id=536e4b47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536e4b47",
  null
  
)

export default component.exports